import styled from '@emotion/styled';
import { Colors, Shadows } from '@zapier/design-system';
import { Link } from 'components/Link/Link';

type UniversalNavLinkType = {
  href: string;
  text: string;
  description?: string;
};

type Props = {
  /**
   * Array of links to render within dropdown menu.
   */
  links: Array<UniversalNavLinkType>;
};

export const Submenu = (props: Props) => {
  return (
    <Outer>
      <List>
        {props.links.map(({ href, text }) => (
          <li key={text}>
            <StyledLink href={href}>
              <LinkInner>
                <LinkTitle>{text}</LinkTitle>
              </LinkInner>
            </StyledLink>
          </li>
        ))}
      </List>
    </Outer>
  );
};

const LinkInner = styled.div`
  transform: translateY(1px);
`;

const StyledLink = styled(Link)`
  display: block;
  border-radius: 10px;
  color: ${Colors.grey700};
  line-height: 20px;
  font-size: 14px;
  padding: 10px;

  &:hover,
  &:focus {
    color: ${Colors.blue500};
    background-color: ${Colors.blue100};
  }
`;

const LinkTitle = styled.p`
  display: block;
  font-weight: 600;
`;

const List = styled.ul`
  display: grid;
  grid-template-columns: 100%;
  gap: 5px;
`;

const Outer = styled.div`
  background-color: ${Colors.white};
  border-radius: 0 0 10px 10px;
  padding: 20px;
  box-shadow: ${Shadows.elevation20};
`;
